import React from 'react';
import { getConfig } from '../../../../utils/config';
import useTagsData from '../data';

import IosArrowForward from '@meronex/icons/ios/IosArrowForward';

function BlogCategories({ onFilterClick, filters }) {
    const { tags } = useTagsData({ type: 'BLOG' });
    const config = getConfig();
    console.log('BLOG CATEGORIES', tags);
    return (
        <div>
            <h1
                className={` ${config?.blogs.fontHeading}
                    mb-4 text-primary text-lg uppercase font-semibold tracking-wider
                `}
                style={{
                    color: config?.blogs?.primaryColor
                }}
            >
                Categories
            </h1>
            {tags?.map((tag) => (
                <div className="mb-2 flex">
                    <IosArrowForward
                        className=" self-center text-primary"
                        style={{
                            color: config?.blogs?.primaryColor
                        }}
                    />
                    <button
                        onClick={() => onFilterClick(tag.id)}
                        className={`${
                            filters.includes(tag.id)
                                ? 'text-info'
                                : `${config?.commonComponents?.blogHeadingColor}`
                        } hover:text-primary self-start text-left pl-2`}
                    >
                        {tag.name}
                    </button>
                </div>
            ))}
        </div>
    );
}

export default BlogCategories;
